import {
  ListPersonsByPhoneLegacyRequest,
  PersonsResponse,
  SearchPersonsLegacyRequest,
} from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons_service.pb';
import { useQuery, UseQueryOptions } from 'react-query';
import { HttpError } from '@frontend/fetch';
import { ContextlessQueryObserverOptions } from '@frontend/react-query-helpers';
import { SchemaPersonV3Service } from '@frontend/schema';
import { convolutedInsanityCombinedPersonV3SearchKeys } from './query-keys';

const defaultOptions: ContextlessQueryObserverOptions = {
  refetchOnWindowFocus: false,
  refetchOnMount: true,
};

export const useSearchPersonsLegacyPostQuery = (
  req: SearchPersonsLegacyRequest,
  options?: UseQueryOptions<PersonsResponse, HttpError>
) =>
  useQuery({
    queryKey: convolutedInsanityCombinedPersonV3SearchKeys.searchPersonsLegacyPost(req),
    queryFn: () => SchemaPersonV3Service.SearchPersonsLegacyPost(req),
    ...defaultOptions,
    ...options,
  });

export const useListPersonsByPhoneLegacyQuery = (
  req: ListPersonsByPhoneLegacyRequest,
  options?: UseQueryOptions<PersonsResponse, HttpError>
) =>
  useQuery({
    queryKey: convolutedInsanityCombinedPersonV3SearchKeys.listPersonsByPhoneLegacy(req),
    queryFn: () => SchemaPersonV3Service.ListPersonsByPhoneLegacy(req),
    ...defaultOptions,
    ...options,
  });

export const useSearchPersonsByPMIDLegacyQuery = (
  req: SearchPersonsLegacyRequest,
  options?: UseQueryOptions<PersonsResponse, HttpError>
) =>
  useQuery({
    queryKey: convolutedInsanityCombinedPersonV3SearchKeys.searchPersonsByPMIDLegacy(req),
    queryFn: () => SchemaPersonV3Service.SearchPersonsByPMIDLegacy(req),
    ...defaultOptions,
    ...options,
  });
